import { Avatar as ANTDAvatar, AvatarProps } from 'antd'
import { useTenant } from './contexts/tenant/TenantContext'
import { FC } from 'react'

export const TenantAvatar: FC<AvatarProps> = ({ size }) => {
  const { tenant } = useTenant()

  return <ANTDAvatar size={size ?? 45} shape="square" src={tenant.logo} />
}

export type TenantAvatarType = { Avatar: typeof TenantAvatar }
